import { createAsyncThunk,createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { CustomFieldStateClass } from "./interfaces/CustomFieldStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";
import { TRUE } from "sass";
import { sortData } from "../../../common/timeLiveFunction";


const initialState : CustomFieldStateClass ={
    isLoading:false,
    status : "idle",
    isReload : false,
    selectedRecord:{},
    customFieldList:[],
    masterEntityTypeList:[],
    sortOrder: 'asc',
    sortColumn: 'MasterEntityTypeName',
    search: '',
    pageNo: 1,
    pageSize: 10
    
}

interface IThunkApi{
    state:{
        customField:CustomFieldStateClass
    }
}

export const getMasterEntityTypeAsync = createAsyncThunk
<any,void,IThunkApi>
(
    "CustomFields/V2/getMasterEntityType",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/V2/CustomFields/MasterEntityType","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }

)

export const getDataByMasterEntityTypeIdAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "CustomFields/V2/getDataByMasterEntityTypeId",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/V2/CustomFields/DataByMasterEntityTypeId/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const getAccountCustomFieldByAccountIdandAccountCustomFieldIdAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "CustomFields/V2/getAccountCustomFieldByAccountIdandAccountCustomFieldId",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/V2/CustomFields/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const addAccountCustomFieldAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "CustomFields/V2/addAccountCustomField",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/V2/CustomFields/","POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const updateAccountCustomFieldAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "CustomFields/V2/updateAccountCustomField",
    async (arg,thunkApi)=>{
        const {AccountCustomFieldId,...argWithoutId} = arg;
        const response = await fetchAPI("api/V2/CustomFields/"+AccountCustomFieldId,"PUT",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)
export const updateIsDisabledAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "CustomFields/V2/updateIsDisabled",
    async (arg,thunkApi)=>{
        const {AccountCustomFieldId,IsDisabled,...argWithoutId} = arg;
        const response = await fetchAPI("api/V2/CustomFields/UpdateIsDisabled/"+AccountCustomFieldId,"PUT",{AccountCustomFieldId:AccountCustomFieldId,IsDisabled:IsDisabled},true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const deleteAccountCustomFieldAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "CustomFields/V2/deleteAccountCustomField",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/V2/CustomFields/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)
export const DeleteSelectedAccountCustomFieldAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "CustomFields/v2/DeleteSelectedAccountCustomField",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/CustomFields/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
const customFieldSlice = createSlice({
    name:"customField",
    initialState,
    reducers:{
        resetSelectedRecordObjectInState:(state)=>{
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.customFieldList.findIndex((item) => item.AccountCustomFieldId == action.payload);
            const newArray = [...state.customFieldList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.customFieldList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.customFieldList.findIndex((item) => item.AccountCustomFieldId == action.payload);
            const newArray = [...state.customFieldList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.customFieldList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.customFieldList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.customFieldList = newArray;
            
        },
        unCheckedAllState: (state) => {
            const newArray = state.customFieldList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.customFieldList = newArray;
           
        },
        checkAllCheckboxIsUncheckedState: (state) => {
           
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.customFieldList;
            state.customFieldList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        },
        LinkClicked: (state, action) => {
            state.isReload = action.payload; 
        },
    },
    extraReducers:(builder) =>{
        builder
        .addCase(getMasterEntityTypeAsync.pending,(state)=>{
            state.status = "loading";
            state.isLoading = true;

        })
        .addCase(getMasterEntityTypeAsync.fulfilled,(state,{payload})=>{
            state.status = "idle";
            state.masterEntityTypeList = payload.Data;
            state.isReload = false;
            state.selectedRecord = {};
            state.isLoading = false;

        })
        .addCase(getMasterEntityTypeAsync.rejected,(state)=>{
            state.status = "failed";
            state.isLoading = false;

        })

        .addCase(getDataByMasterEntityTypeIdAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;

        })
        .addCase(getDataByMasterEntityTypeIdAsync.fulfilled, (state, { payload }) => {
            state.status = "idle";
            if (Object.keys(payload.Data).length === 0) {
                state.customFieldList = [];
            } else {
                state.customFieldList = payload.Data;
                state.customFieldList.map((item: any) => {
                    item.isSelected = 0
                });
            }
            state.isReload = false;
            state.selectedRecord = {};
            state.isLoading = false;

            
        })
        .addCase(getDataByMasterEntityTypeIdAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(getAccountCustomFieldByAccountIdandAccountCustomFieldIdAsync.pending, (state) => {
            state.status = 'loading';
            //state.isLoading = true;
        })
        .addCase(getAccountCustomFieldByAccountIdandAccountCustomFieldIdAsync.fulfilled, (state, { payload }) => {
            // state.status = 'idle';
            // if (Object.keys(payload.Data).length === 0) {
            //     state.selectedRecord = {};
            // } else {
            //     state.selectedRecord = payload.Data[0];
            // }
            state.status = 'idle';
            state.selectedRecord = payload.Data[0];
           // state.isLoading = false;
        })
        .addCase(getAccountCustomFieldByAccountIdandAccountCustomFieldIdAsync.rejected, (state) => {
            state.status = 'failed';
            //state.isLoading = false;
        })

        .addCase(addAccountCustomFieldAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(addAccountCustomFieldAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(addAccountCustomFieldAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(updateAccountCustomFieldAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(updateAccountCustomFieldAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';        
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(updateAccountCustomFieldAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(updateIsDisabledAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;

        })
        .addCase(updateIsDisabledAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';        
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(updateIsDisabledAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(deleteAccountCustomFieldAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(deleteAccountCustomFieldAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(deleteAccountCustomFieldAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })
        .addCase(DeleteSelectedAccountCustomFieldAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;           
        })
        .addCase(DeleteSelectedAccountCustomFieldAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(DeleteSelectedAccountCustomFieldAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })
    }
})

export const {resetSelectedRecordObjectInState,LinkClicked, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updateSorting, updatePagination} = customFieldSlice.actions
export const CustomFieldState = (state : RootState)=>state.customField
export default customFieldSlice.reducer


